import http, { Http } from '@/lib/http';
import { OrderPayment, ScheduleChanges } from '../types';
import { getScheduleChangesPayload } from './helpers';

interface Params {
  orderId: string;
  projectId: string;
  scheduleStaticIdentifier: string;
  originalSchedule: OrderPayment[];
  changes: ScheduleChanges;
}

function updateScheduleCtor(http: Http) {
  return async (params: Params): Promise<void> => {
    const {
      projectId,
      orderId,
      scheduleStaticIdentifier,
      originalSchedule,
      changes,
    } = params;

    await http.post(`/projects/${projectId}/schedules/${orderId}`, {
      updates: getScheduleChangesPayload(originalSchedule, changes),
      scheduleStaticIdentifier,
    });
  };
}

export const updateSchedule = updateScheduleCtor(http);
